import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Sant Adrià de Besòs – Compra de Coches',
  description: 'Compramos coches en Sant Adrià de Besòs al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Sant Adrià de Besòs', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Sant Adrià de Besòs' },
  url: `${siteUrl}/desguace-sant-adria`,
};

export default function DesguaceSantAdriaPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Sant Adrià de Besòs | Mejor Precio | Recogida Gratis"
        description="Desguace en Sant Adrià de Besòs. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en Sant Adrià y pago inmediato."
        keywords="desguace Sant Adrià, vender coche Sant Adrià Besòs, compra coches Sant Adrià, desguace Barcelonès"
        canonical={`${siteUrl}/desguace-sant-adria`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Sant Adrià de Besòs
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Compramos tu coche en cualquier estado en Sant Adrià de Besòs y alrededores. Recogida gratuita y pago inmediato.
            </p>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Desguace Sant Adrià de Besòs</strong> es tu mejor opción para vender tu coche en esta ciudad del Barcelonès. Ofrecemos servicio de recogida gratuita en todos los barrios de Sant Adrià, desde La Mina hasta el Besòs, pasando por Sant Adrià Nord y todas las demás zonas.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Con más de <strong>15 años de experiencia</strong> en el sector, hemos comprado miles de vehículos en Sant Adrià de Besòs. No importa si tu coche está siniestrado, averiado, sin ITV o simplemente quieres deshacerte de él, te ofrecemos el mejor precio del mercado.
              </p>
            </div>

            {/* Barrios que cubrimos */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Barrios de Sant Adrià Donde Operamos
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Cubrimos todos los barrios de Sant Adrià de Besòs. Nuestro equipo puede recoger tu vehículo en cualquier punto de la ciudad:
              </p>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                {['La Mina', 'El Besòs', 'Sant Adrià Nord', 'La Catalana', 'Sant Joan Baptista', 'Marina del Besòs', 'El Sot', 'Centre'].map((barrio) => (
                  <div key={barrio} className="bg-[#f8f9fa] p-4 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] text-xl mb-2"></i>
                    <p className="text-sm font-medium text-[#1a2332]">{barrio}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Ventajas */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Ventajas de Vender tu Coche en Sant Adrià de Besòs
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Recogida Rápida</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Al estar cerca de Barcelona, podemos recoger tu coche en 24-48 horas. Servicio express disponible.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Mejor Precio</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Ofrecemos las mejores tasaciones de Sant Adrià. Superamos ofertas de la competencia.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-truck-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Grúa Gratuita</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recogemos tu coche donde esté: garaje, parking, calle o taller. Sin coste adicional.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-file-list-3-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Trámites Incluidos</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Gestionamos toda la documentación: baja en Tráfico, certificado de destrucción y más.
                  </p>
                </div>
              </div>
            </section>

            {/* Tipos de coches */}
            <section className="mb-16 bg-[#f8f9fa] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Coches que Compramos en Sant Adrià de Besòs
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches siniestrados:</strong> Vehículos con daños por accidente, siniestro total declarado por aseguradora.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches averiados:</strong> Averías mecánicas, eléctricas, motor fundido, caja de cambios rota.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches sin ITV:</strong> Vehículos con ITV caducada o que no pueden pasar la inspección.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches viejos:</strong> Vehículos antiguos, con muchos kilómetros o que ya no usas.</p>
                </div>
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche en Sant Adrià de Besòs Hoy
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Tasación gratuita y sin compromiso en menos de 24 horas
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20en%20Sant%20Adri%C3%A0%20de%20Bes%C3%B2s" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-[#25d366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp 932 932 913
              </a>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
